import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Phone, Mail, MapPin } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-[#102A2A] text-[#EAF3EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center h-9 w-9 rounded-xl bg-[#087A73] text-white">EC</span>
            <span className="text-xl font-extrabold text-white">EtruriaCare</span>
          </div>
          <p className="text-sm text-[#EAF3EF]/70 leading-relaxed">
            Assistenza sanitaria a domicilio ad Arezzo e provincia. Un intermediario tecnologico che collega famiglie e professionisti qualificati.
          </p>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4">Documenti legali</h4>
          <ul className="space-y-2 text-sm text-[#EAF3EF]/75">
            <li><Link to="/legal/privacy" data-testid="footer-privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/legal/cookie" className="hover:text-white">Cookie Policy</Link></li>
            <li><Link to="/legal/termini" data-testid="footer-terms" className="hover:text-white">Termini e Condizioni</Link></li>
            <li><Link to="/legal/professionisti" className="hover:text-white">Informativa Professionisti</Link></li>
            <li><Link to="/legal/cancellazione" className="hover:text-white">Politica di Cancellazione</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4">Contatti</h4>
          <ul className="space-y-3 text-sm text-[#EAF3EF]/75">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#087A73]" /> 388 245 4770</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#087A73]" /> etruriacare@icloud.com</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#087A73]" /> Arezzo, Toscana</li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4">Avviso importante</h4>
          <p className="text-xs text-[#EAF3EF]/60 leading-relaxed">
            EtruriaCare non fornisce diagnosi, prescrizioni o telemedicina. La valutazione clinica e la prestazione restano di esclusiva responsabilità del professionista sanitario. Dati demo — nessun dato clinico raccolto.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#EAF3EF]/50">
        © {new Date().getFullYear()} EtruriaCare — Prototipo dimostrativo. Tutti i dati mostrati sono fittizi.
      </div>
    </footer>
  );
}
